import { render } from "./MdmBatchApprovalList.vue?vue&type=template&id=25d7c959&scoped=true"
import script from "./MdmBatchApprovalList.vue?vue&type=script&lang=js"
export * from "./MdmBatchApprovalList.vue?vue&type=script&lang=js"

import "./MdmBatchApprovalList.vue?vue&type=style&index=0&id=25d7c959&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d7c959"]])

export default __exports__